import type { EcuNode, LogEvent } from '../types/console'

export const ecuNodes: EcuNode[] = [
  {
    id: 'camera',
    name: 'Camera ECU',
    state: 'secured',
    x: 50,
    y: 9.1,
    labelX: 69.3,
    labelY: 1,
    align: 'right',
  },
  {
    id: 'gateway',
    name: 'Gateway / CAN Hub',
    state: 'monitoring',
    x: 50,
    y: 30.3,
    labelX: 1.8,
    labelY: 19.2,
    align: 'left',
  },
  {
    id: 'adas',
    name: 'ADAS Controller',
    state: 'secured',
    x: 57.8,
    y: 48,
    labelX: 71.6,
    labelY: 39.4,
    align: 'right',
  },
  {
    id: 'brake',
    name: 'Brake ECU',
    state: 'secured',
    x: 42.2,
    y: 48,
    labelX: 0,
    labelY: 47,
    align: 'left',
  },
  {
    id: 'infotainment',
    name: 'Infotainment ECU',
    state: 'blocked',
    x: 50,
    y: 61.6,
    labelX: 69.7,
    labelY: 60.6,
    align: 'right',
  },
  {
    id: 'telematics',
    name: 'Telematics ECU',
    state: 'secured',
    x: 50,
    y: 75.8,
    labelX: 1.8,
    labelY: 75.8,
    align: 'left',
  },
]

export const logEvents: LogEvent[] = [
  {
    time: '14:02:11',
    source: 'Gateway / CAN',
    description: 'Unauthorized frame injection',
    outcome: 'blocked',
  },
  {
    time: '14:02:08',
    source: 'Infotainment',
    description: 'Anomalous process spawn',
    outcome: 'blocked',
  },
  {
    time: '14:01:54',
    source: 'ADAS Controller',
    description: 'Firmware signature verified',
    outcome: 'secured',
  },
  {
    time: '14:01:39',
    source: 'Telematics ECU',
    description: 'OTA package validated',
    outcome: 'secured',
  },
  {
    time: '14:01:22',
    source: 'Brake ECU',
    description: 'CAN traffic nominal',
    outcome: 'secured',
  },
]
